import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Badge, Col, Row } from "react-bootstrap";
import fieldImage from "../../../assets/images/field.png";
import offloadImage from "../../../assets/images/offload.png";
import sourceEgImage from "../../../assets/images/source_eg.png";
import targetEgImage from "../../../assets/images/target_eg.png";
import { toDisplayDateTimeString } from "../../helpers/moment-ex";
import { loadEntity } from "../../helpers/common";
import { Icon } from "../widgets";
import "../../../assets/scss/load-timeline.scss";

const LoadTimeLine = ({ setShowTimeLine, loadInfo }) => {
  const loadTimeLineData = useSelector((state) => state.load.loadTimeLine.data);
  const isRequesting = useSelector(
    (state) => state.load.loadTimeLine.isRequesting
  );
  const harvesterList = useSelector(
    (state) => state.equipmentGroup.harvesterList
  );

  const isAutomaticLoad = useMemo(() => {
    if (
      (loadInfo &&
        loadInfo.hasOwnProperty("load_type") &&
        loadInfo.load_type === 1) ||
      (Array.isArray(harvesterList) && harvesterList.length === 0)
    ) {
      return true;
    }

    return false;
  }, [loadInfo]);

  const [crewName, setCrewName] = useState(null);
  const [timeLineData, setTimeLineData] = useState([]);

  useEffect(() => {
    // const dataOrder = ['offload', 'transport', 'transport', 'target_equipment_group', 'source_equipment_group', 'field', 'crew'];
    let dataOrder = [
      "offload",
      "target_equipment_group",
      "source_equipment_group",
      "field",
      "crew",
    ];

    if (loadTimeLineData) {
      let load = [];
      dataOrder.forEach((item) => {
        let data = {};
        let entityTypeId = null;
        const timeLineDatas = loadTimeLineData[item];

        if (timeLineDatas && timeLineDatas.length > 0) {
          entityTypeId = timeLineDatas[0].entity_type_id;
          let label = loadEntity.filter(
            (e) => e.entity_type_id === entityTypeId
          );
          label = label.length > 0 ? label[0].label : "Unknown";

          timeLineDatas.forEach((e) => {
            data = {
              ...data,
              ...e,
              label,
              created_date: e.created_date ? e.created_date : data.created_date,
              approved_date: e.approved_date
                ? e.approved_date
                : data.approved_date,
            };
          });

          if (data.entity_type_id === 3) setCrewName(data.crew_name);
          else if (
            data.entity_type_id === 10 &&
            !data.transload_geo_region_name
          ) {
          } else if (
            data.entity_type_id === 12 &&
            !data.transport_equipment_group_name
          ) {
          } else load.push(data);
        }
      });
      setTimeLineData(load);
    }
  }, [loadTimeLineData]);

  const formatDate = (date, includeDate = false, approved = false) => {
    if (!date) return <></>;

    const time = moment.utc(date).format("hh:mm a");
    const dateWithTime = toDisplayDateTimeString(date, false, false);
    const timeIcon = <i className="fa fa-clock-o" />;
    const approvedIcon = (
      <Badge
        title="Approved"
        variant="success"
        style={{ padding: "5px" }}
        className="badge-sm mr-1"
        pill
      >
        <Icon className="fa fa-check" />
      </Badge>
    );
    const icon = approved ? approvedIcon : timeIcon;

    if (includeDate)
      return (
        <>
          {" "}
          {icon} {dateWithTime}{" "}
        </>
      );
    else
      return (
        <>
          {icon} {time}
        </>
      );
  };

  const getNames = (entityId, points) => {
    let name = null;
    let icon = null;
    let image = null;
    let regionName = null;
    let shapeName = null;
    let fieldStartDate = null;
    let storageLocation = null;
    let operatorName = null;
    let approved = null;
    let modifiedDate = null;
    let loadStartDate = null;
    let loadEndDate = null;
    let isField = false;
    let label = null;

    switch (entityId) {
      case 2:
        image = fieldImage;
        icon = "icon icon-map-shape";
        isField = true;
        label = "FIELD";
        regionName = points.field_geo_region_name
          ? points.field_geo_region_name
          : "Unknown";
        shapeName = points.field_geo_shape_name
          ? points.field_geo_shape_name
          : "Unknown";
        fieldStartDate = points.start_date
          ? formatDate(points.start_date, true, false)
          : null;
        break;
      case 3:
        icon = "fa fa-users";
        name = points.crew_name ? points.crew_name : "Unknown";
        break;
      case 5:
        image = isAutomaticLoad ? targetEgImage : sourceEgImage;
        icon = isAutomaticLoad ? "fa fa-truck" : "fa fa-cart-plus";
        name = isAutomaticLoad
          ? points.target_equipment_group_name
          : points.source_equipment_group_name;
        operatorName = isAutomaticLoad
          ? points.operator_name
          : points.source_operator_name;
        loadStartDate = loadInfo ? loadInfo.start_date : null;
        label = isAutomaticLoad
          ? "TRUCK"
          : points.equipment_category_name
          ? points.equipment_category_name.toUpperCase()
          : "HARVESTER";
        break;
      case 7:
        image = targetEgImage;
        icon = "fa fa-truck";
        name = points.target_equipment_group_name;
        operatorName = points.operator_name;
        loadStartDate = loadInfo ? loadInfo.end_date : null;
        label = points.equipment_category_name
          ? points.equipment_category_name.toUpperCase()
          : "TRUCK";
        break;
      case 10:
        name = points.transload_geo_region_name;
        break;
      case 12:
        name = points.transport_equipment_group_name;
        break;
      case 15:
        image = offloadImage;
        approved = "fa fa-check";
        label = "OFFLOAD";
        modifiedDate = points.modified_date ? points.modified_date : "Unknown";
        // regionName = points.offload_geo_region_name ? points.offload_geo_region_name : "Unknown"
        regionName = points.offload_geo_shape_name
          ? points.offload_geo_shape_name
          : "Unknown";
        shapeName = points.offload_geo_shape_name
          ? points.offload_geo_shape_name
          : "Unknown";
        storageLocation =
          shapeName && shapeName !== "Unknown"
            ? points.offload_geo_storage_location_name
              ? points.offload_geo_storage_location_name
              : "Unknown"
            : null;
        break;
      default:
        break;
    }

    return {
      name,
      icon,
      image,
      operatorName,
      regionName,
      shapeName,
      storageLocation,
      fieldStartDate,
      approved,
      modifiedDate,
      loadStartDate,
      loadEndDate,
      isField,
      label,
    };
  };

  const getRightCard = (data) => {
    const {
      image,
      icon,
      operatorName,
      name,
      loadStartDate,
      loadEndDate,
      label,
    } = getNames(data.entity_type_id, data);
    const imageHtml = image ? (
      <img style={{ width: "45px" }} src={image} alt="" />
    ) : (
      <span>
        <i className={icon}></i>
        {name ? name : "Unknown"}
      </span>
    );

    return (
      <div className="row timeline-right" key={data.entity_type_id}>
        <div className="col-md-6">
          <p className="timeline-date">
            {formatDate(
              loadStartDate
                ? loadStartDate
                : loadEndDate
                ? loadEndDate
                : data.created_date,
              false,
              false
            )}
          </p>
        </div>
        <Row className="content-box">
          <Col className="timeline-box shadow">
            <div className="timeline-icon">{imageHtml}</div>
            <div className="timeline-text">
              <h3 title={name}>{name ? name : "Unknown"}</h3>
              <p title={operatorName} style={{ opacity: "0.8" }}>
                <i className="fa fa-user mr-1" />{" "}
                {operatorName ? operatorName : "Unknown"}
              </p>
            </div>
          </Col>
          <span
            className="vertical-text shadow"
            style={{
              borderTopRightRadius: "6px",
              borderBottomRightRadius: "6px",
            }}
          >
            {label}
          </span>
        </Row>
      </div>
    );
  };

  const getLeftCard = (data) => {
    const { shapeName, icon, storageLocation, image, label } = getNames(
      data.entity_type_id,
      data
    );
    const imageHtml = image ? (
      <img style={{ width: "45px" }} src={image} alt="" />
    ) : (
      <i className={icon}></i>
    );
    const approveDate =
      data.entity_type_id !== 2 && loadTimeLineData
        ? formatDate(
            loadTimeLineData.approved_date,
            moment(loadTimeLineData.approved_date).format("DD MMM YYYY") !==
              moment(loadInfo ? loadInfo.start_date : 0).format("DD MMM YYYY"),
            true
          )
        : null;

    return (
      <div className="row timeline-left" key={data.entity_type_id}>
        <div className="col-md-6">
          <Row className="content-box">
            <Col
              className="timeline-box shadow"
              style={{
                marginRight: "11px",
                paddingLeft: "0px",
                maxWidth: "220px",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
              }}
            >
              <span
                className="vertical-text"
                style={{
                  marginTop: "0px",
                  transform: "rotate(180deg)",
                  borderTopRightRadius: "6px",
                  borderBottomRightRadius: "6px",
                }}
              >
                {label}
              </span>
              <div style={{ paddingRight: "15px" }} className="timeline-text">
                <h3 title={shapeName}>{shapeName ? shapeName : ""}</h3>
                <p title={storageLocation}>
                  {storageLocation ? (
                    <>
                      <Icon className="mr-1 fa fa-database" /> {storageLocation}{" "}
                    </>
                  ) : (
                    ""
                  )}
                </p>
              </div>
              <div className="timeline-icon d-md-block d-none">{imageHtml}</div>
            </Col>
          </Row>
        </div>
        <div className="col-md-6 d-md-block d-none">
          <p className="timeline-date">{approveDate && approveDate}</p>
        </div>
      </div>
    );
  };

  const getTimeLine = () => {
    if (timeLineData && timeLineData.length === 0) return <></>;

    let index = 0;
    let result = [];

    const graphData = timeLineData.map((e) => {
      if (isAutomaticLoad && e.hasOwnProperty("source_equipment_group_name")) {
        const truckData = timeLineData.find((e) =>
          e.hasOwnProperty("target_equipment_group_name")
        );
        const {
          target_equipment_group_name,
          target_equipment_group_uuid,
        } = truckData;

        if (target_equipment_group_name && target_equipment_group_uuid) {
          return {
            ...e,
            target_equipment_group_name,
            target_equipment_group_uuid,
          };
        } else return e;
      } else return e;
    });

    for (const item of graphData) {
      index = index + 1;

      if (index === timeLineData.length || index - 1 === 0) {
        const html = getLeftCard(item);
        result.push(html);
      } else {
        const html = getRightCard(item);
        result.push(html);
      }
    }

    return <>{result.map((e) => e)}</>;
  };

  return (
    <div
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={true}
      onHide={() => setShowTimeLine(false)}
      className="timeline-modal"
    >
      <div
        className="py-0 moadl-body"
        style={{ overflowX: "hidden", overflowY: "auto" }}
      >
        <div className="timeline">
          {!isRequesting ? (
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="timeline-container">
                    <div className="timeline-continue">{getTimeLine()}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div style={{ position: "absolute", right: "50%", top: "200px" }}>
              Loading...
            </div>
          )}
        </div>

        <Row
          style={{ paddingLeft: "43px", paddingTop: "25px", marginTop: "-5px" }}
        >
          {!isRequesting && (
            <>
              <Col className="col-8">
                <i className="fa fa-users mr-2" />
                {crewName ? crewName : "Unknown"}
              </Col>
              <Col className="col-4">
                {loadInfo && loadInfo.start_date ? (
                  <>
                    <Icon className="fa fa-calendar" />{" "}
                    {moment.utc(loadInfo.start_date).format("DD MMM YYYY")}
                  </>
                ) : (
                  <></>
                )}
              </Col>
            </>
          )}
        </Row>
      </div>
    </div>
  );
};

export default LoadTimeLine;